var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6641_26412",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6641_26412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H8.25C8.4625 2.25 8.64063 2.32187 8.78438 2.46562C8.92813 2.60938 9 2.7875 9 3C9 3.2125 8.92813 3.39062 8.78438 3.53437C8.64063 3.67813 8.4625 3.75 8.25 3.75H3.75V14.25H8.25C8.4625 14.25 8.64063 14.3219 8.78438 14.4656C8.92813 14.6094 9 14.7875 9 15C9 15.2125 8.92813 15.3906 8.78438 15.5344C8.64063 15.6781 8.4625 15.75 8.25 15.75H3.75ZM12.8813 9.75H7.5C7.2875 9.75 7.10938 9.67813 6.96562 9.53438C6.82188 9.39063 6.75 9.2125 6.75 9C6.75 8.7875 6.82188 8.60938 6.96562 8.46563C7.10938 8.32188 7.2875 8.25 7.5 8.25H12.8813L11.475 6.84375C11.3375 6.70625 11.2688 6.5375 11.2688 6.3375C11.2688 6.1375 11.3375 5.9625 11.475 5.8125C11.6125 5.6625 11.7875 5.58437 12 5.57812C12.2125 5.57188 12.3938 5.64375 12.5438 5.79375L15.225 8.475C15.375 8.625 15.45 8.8 15.45 9C15.45 9.2 15.375 9.375 15.225 9.525L12.5438 12.2063C12.3938 12.3563 12.2156 12.4281 12.0094 12.4219C11.8031 12.4156 11.625 12.3375 11.475 12.1875C11.3375 12.0375 11.2719 11.8594 11.2781 11.6531C11.2844 11.4469 11.3562 11.275 11.4937 11.1375L12.8813 9.75Z",
    fill: "#482481"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.5a7269a5f4d73750cfffeb988719f3f6.svg";
export { ForwardRef as ReactComponent };